import { $current } from '@bingads-webui-react/scope-service';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';

export function updateUrlOnCampaignTypeChange(scope) {
  scope.remove('campaignId');
  scope.remove('adGroupId');
  scope.remove('assetGroupId');

  return scope.save();
}

export function getSmartPath(scope) {
  const { uid, cid, aid } = scope.values;
  return `/campaign/smart?uid=${uid}&cid=${cid}&aid=${aid}`;
}

export function getSmartCampaignUrl(node, scope) {
  const path = getSmartPath(scope);
  return node.rawStatus === 'InProgress' ?
    `${path}#/CreateCampaign/${node.id}` :
    `${path}#/campaign/${node.id}`;
}

export function updateUrlOnTreeNodeChange(node, scope) {
  const newScope = node.parentId ?
    {
      campaignId: node.parentId,
      adGroupId: node.id,
    } : {
      campaignId: node.id,
    };
  if (node.campaignType === CampaignType.Smart) {
    window.location.href = getSmartCampaignUrl(node, scope);
    return false;
  }

  scope.set({
    uid: $current,
    cid: $current,
    aid: $current,
    ...newScope,
  });

  scope.remove('recommendationType');
  return scope.save();
}
